import { 
  faList, faLocationDot, faPhone, faPen, faShare, faXmark, 
  faUser, faUpload, faRotateRight, faEye, faPenToSquare, faFloppyDisk, 
  faCheck, faTrash, faClipboardCheck, faBan, faLock, faMap, 
  faRightFromBracket, faBell, faLanguage, faChevronRight,
  faChevronDown, faSignature, faCircleQuestion, faArrowUpRightFromSquare,
  faEyeSlash, faHandshakeAngle, faThumbsUp, faQuestion, faPaperPlane,
  faUserShield, faDownload, faExclamationCircle, faCompass, faSpinner,
  faArrowUpFromBracket, faQuestionCircle, faBars, faPlus, faMagnifyingGlass,
  faLink
} from '@fortawesome/free-solid-svg-icons';
import { faPlusSquare } from '@fortawesome/fontawesome-free-regular';

export const icons = {
  list: faList,
  locationDot: faLocationDot,
  phone: faPhone,
  pen: faPen,
  share: faShare,
  xmark: faXmark,
  user: faUser,
  upload: faUpload,
  rotateRight: faRotateRight,
  eye: faEye,
  penToSquare: faPenToSquare,
  floppyDisk: faFloppyDisk,
  check: faCheck,
  trash: faTrash,
  clipboardCheck: faClipboardCheck,
  ban: faBan,
  lock: faLock,
  map: faMap,
  rightFromBracket: faRightFromBracket,
  chevronDown: faChevronDown,
  bell: faBell,
  language: faLanguage,
  chevronRight: faChevronRight,
  signature: faSignature,
  cirlceQuestion: faCircleQuestion,
  arrowUpRightFromSquare: faArrowUpRightFromSquare,
  eyeSlash: faEyeSlash,
  handshakeAngle: faHandshakeAngle,
  thumbsUp: faThumbsUp,
  question: faQuestion,
  paperPlane: faPaperPlane,
  userShield: faUserShield,
  download: faDownload,
  exclamationCircle: faExclamationCircle,
  spinner: faSpinner,
  compass: faCompass,
  arrowUpFromBracket: faArrowUpFromBracket, 
  questionCircle: faQuestionCircle,
  bars: faBars,
  plus: faPlus,
  magnifyingGlass: faMagnifyingGlass,
  plusSquare: faPlusSquare,
  link: faLink
};